import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SysUsersService } from './services/sys-users.service';
const Lockr = require("lockr");
@Injectable({
  providedIn: 'root'
})
export class AccountGuard implements CanActivate  {
  constructor(
    private userService: SysUsersService,
    public router: Router,
  ) { }

  canActivate(): Promise<boolean> | boolean {
    return new Promise(async resolve => {
      const user = Lockr.get('user');
      let accountId;
      let isSuperAdmin;
      if (user.account) {
        accountId = user.account;
      } else {
        accountId = user.user_id;
        isSuperAdmin = true;
      }

      const [error, data] = await this.userService.checkIfUserCanUsePlatform(accountId, isSuperAdmin) as any;
      if (error) return error;

      if (data.signature && data.firstStationExists) {
        this.router.navigate(['/pages/notificaciones']);
        return resolve(false);
      }

      return resolve(true);
    });
  }
}
